import { Component, ElementRef, ViewChild, Renderer2, HostListener, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import Swiper from 'swiper';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-entertainment',
  templateUrl: './entertainment.component.html',
  styleUrls: ['./entertainment.component.css']
})
export class EntertainmentComponent implements OnInit {
  isBrowser: boolean = false;
  baseUrl = Constants.baseUrl;

  constructor(private renderer: Renderer2, private elementRef: ElementRef, private titleService: Title,
    private metaService: Meta, @Inject(PLATFORM_ID) private platformId: any, private _renderer2: Renderer2, private seoService: SeoService,
    @Inject(DOCUMENT) private _document: Document,
  ) { this.isBrowser = isPlatformBrowser(this.platformId); }




  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
 {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/entertainment/"
  },
  "headline": "Media and Entertainment IT Solutions and Services | Maganti IT",
  "description": "The media & entertainment sector is undergoing a major IT transformation helping reach a vast audience worldwide.",
  "image": "https://mitresource.com/assets/images/manufacture/Futek.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-24"
}`;

    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500, });
    }
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Media and Entertainment IT Solutions and Services | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'The media & entertainment sector is undergoing a major IT transformation helping reach a vast audience worldwide.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Media and Entertainment IT Solutions and Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/entertainment/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/manufacture/Futek.png' },
      { property: 'og:description', content: 'The media & entertainment sector is undergoing a major IT transformation helping reach a vast audience worldwide.' },
    ]);
  }


  scrollToSection(sectionId: string) {
    if (this.isBrowser) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}

